import styled from "@emotion/styled";

export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 0 20px 100px 20px;
  height: 100%;
  overflow-y: auto;
  min-width: 1140px;
  position: relative;
`;

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const BarContainer = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  border-bottom: 1px solid var(--alias-color-line-normal);
  padding: 0px 24px;
  gap: 20px;
  height: 40px;
  box-sizing: border-box;
`;

export const TabContainer = styled.div<{ selected: boolean }>`
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  border-bottom: ${(props) => (props.selected ? "2px solid var(--alias-color-primary-normal)" : "none")};
  cursor: pointer;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  padding: 6px 4px 8px 4px;
  justify-content: center;
  cursor: pointer;

  gap: 4px;
  align-items: center;
  margin-left: auto;
`;

export const SetUpBtn = styled.div`
  position: fixed;
  right: 40px;
  bottom: 60px;
  background-color: white;
  box-shadow: var(--alias-style-shadow-strong);
  border-radius: 8px;
  rotate: 90deg;
`;
